export const LOCALSTORAGE_CONST = {
  CURRENT_USER: 'currentUser'
} as const;
